import { animate, query, state, style, transition, trigger } from '@angular/animations';
import { BreakpointObserver } from '@angular/cdk/layout';
import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { BaseDto } from '@models/base/baseDto.model';
import { AccionesDialog, EstadosContrato, TiposAjusteContrato, TiposLiquidacion, TiposMontos, TiposPunitorio } from '@models/base/identificadores.model';
import { AdendarContratoRequest } from '@models/contrato/adendarContratoRequest.model';
import { ContratoDetailDto } from '@models/contrato/contratoDetailDto.model';
import { ContratoGarantiaDto } from '@models/contrato/contratoGarantiaDto.model';
import { PeriodoContratoDetailDto } from '@models/periodos-contrato/periodoContratoDetailDto.model';
import { PeriodoContratoSummaryDto } from '@models/periodos-contrato/periodoContratoSummaryDto.model';
import { ResindirContratoRequest } from '@models/contrato/resindirContratoRequest.model';
import { UpdateContratoRequest } from '@models/contrato/updateContratoRequest.model';
import { GarantiaSummaryDto } from '@models/garantia/garantiaSummaryDto.model';
import { InquilinoDto } from '@models/inquilino/inquilinoDto.model';
import { CreatePeriodoContratoRequest } from '@models/periodos-contrato/createPeriodoContratoRequest.model';
import { PropiedadDto } from '@models/propiedades/propiedadDto.model';
import { PropietarioDto } from '@models/propietarios/propietarioDto.model';
import { TipoMonedaDto } from '@models/tipo-moneda/tipoMonedaDto.model';
import { ContratosService } from '@services/contratos/contratos.service';
import { GarantiasService } from '@services/garantias/garantias.service';
import { PeriodosContratoService } from '@services/periodos-contrato/periodos-contrato.service';
import { PersonasService } from '@services/personas/personas.service';
import { PropiedadesService } from '@services/propiedades/propiedades.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { isFalsy } from 'utility-types';
import { DialogNuevoPeriodoComponent } from '../form-nuevo-contrato/dialog-nuevo-periodo/dialog-nuevo-periodo.component';
import { Periodo } from '../form-nuevo-contrato/form-nuevo-contrato.component';
import { DialogAdendaContratoComponent } from './dialog-adenda-contrato/dialog-adenda-contrato.component';
import { DialogGenerarResumenComponent } from './dialog-generar-resumen/dialog-generar-resumen.component';
import { DialogNuevaLiquidacionComponent } from './dialog-nueva-liquidacion/dialog-nueva-liquidacion.component';
import { DialogRescisionContratoComponent } from './dialog-rescision-contrato/dialog-rescision-contrato.component';
import { PersonaDetailDto } from '@models/personas/personaDetailDto.model';
import { DialogVerPeriodoContratoDetailDtoComponent } from '@views/periodos-contrato/dialog-ver-periodo-contrato-detail-dto/dialog-ver-periodo-contrato-detail-dto.component';
import { DialogNuevoReciboComponent } from '../dialog-nuevo-recibo/dialog-nuevo-recibo/dialog-nuevo-recibo.component';
import { TiposPunitorioService } from '@services/tipos-punitorio/tipos-punitorio.service';
import { TiposMontoService } from '@services/tipos-monto/tipos-monto.service';
import { FormasPagoService } from '@services/formas-pago/formas-pago.service';
import { TipoLiquidacionService } from '@services/tipo-liquidacion/tipo-liquidacion.service';
import { TipoPunitorioDto } from '@models/tipo-punitorio/tipoPunitorioDto.model';
import { DialogUpdatePeriodoContratoComponent } from '@views/periodos-contrato/dialog-update-periodo-contrato/dialog-update-periodo-contrato.component';

// Animations

@Component({
  selector: 'app-form-editar-contrato',
  templateUrl: './form-editar-contrato.component.html',
  styleUrls: ['./form-editar-contrato.component.css'],
})

export class FormEditarContratoComponent implements OnInit, AfterViewInit {

  estadosContrato = EstadosContrato
  tiposAjusteContrato = TiposAjusteContrato

  data = false
  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }
  }

  applyFilter(event: any) {
    // Validamos que event.target no sea nulo ni undefined
    if (event && event.target && event.target.value !== undefined) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim().toLowerCase();

      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }
  }


  @Input() idContrato!: number

  // Nuevas propiedades para edición de punitorios
  modoEdicionPunitorios: boolean = false;
  punitoriosForm!: FormGroup;
  datosOriginalesPunitorios: any = null;

  // Listas para dropdowns
  lstTiposPunitorio: TipoPunitorioDto[] = [];
  lstTiposMontoPunitorio: BaseDto[] = [];

  //Contrato
  updateContratoRequest = new UpdateContratoRequest
  contratoGarantiaDto = new ContratoGarantiaDto

  //Form Group
  datosPropiedadFormGroup!: FormGroup;
  datosInquilinoFormGroup!: FormGroup;
  datosContratoFormGroup!: FormGroup;
  montosContratoFormGroup!: FormGroup;
  validatorFormGroup!: FormGroup;
  detalleMontosContratorFormGroup!: FormGroup
  isEditable = false;
  //Propiedad
  propiedad: PropiedadDto = new PropiedadDto
  inquilinoDto: InquilinoDto = new InquilinoDto;
  personaInquilino: PersonaDetailDto = new PersonaDetailDto;
  persona!: PersonaDetailDto
  propietariosPropiedad: PropietarioDto[] = []
  garantiasInquilino: GarantiaSummaryDto[] = []
  tieneGarantias: boolean = true;
  dataSource = new MatTableDataSource<PeriodoContratoDetailDto>();
  displayedColumns: string[] = []

  modoEdicionDiaVto: boolean = false;
  diaVencimientoPagoTemp: number = 0;

  // Nuevas propiedades
  modoEdicionPropietario: boolean = false;
  propietarioEditForm!: FormGroup;
  datosOriginalesPropietario: any = null;

  // Listas para dropdowns
  lstFormasPago: BaseDto[] = [];
  lstTiposLiquidacion: BaseDto[] = [];

  //Contrato

  //Totales
  totalMontoAlquiler: number = 0
  totalComision: number = 0
  totalDescuento: number = 0
  totalIncrementos: number = 0
  totalSellado: number = 0
  total: number = 0

  //Totales de cobranza y liquidación (análisis de mora)
  /** Σ importe de los períodos ya vencidos (Fecha Vencimiento <= hoy) */
  totalDevengado: number = 0
  /** Σ importe de los períodos con Fecha Pago */
  totalPagado: number = 0
  /** Σ importe de los períodos sin Fecha Pago, incluidos los que aún no vencieron */
  totalACobrar: number = 0
  /** Σ importe de los períodos sin Fecha Pago Y ya vencidos. Es la mora real. */
  deudaInquilino: number = 0
  /** Σ importe liquidado al propietario que todavía no se le cobró al inquilino */
  liquidadoSinCobrar: number = 0

  /**
   * Σ importe de lo que HOY se le puede rendir al propietario y no se rindió.
   *
   * Depende del tipo de liquidación del contrato, igual que en el back:
   *   - Real: sólo los períodos con fecha de pago.
   *   - Ficticia: los períodos ya vencidos, se hayan cobrado o no.
   *
   * Antes sumaba todo lo que no tuviera fecha de liquidación, incluidos los
   * períodos futuros: mostraba como deuda al propietario alquileres de meses
   * que ni se habían devengado.
   */
  totalPorLiquidar: number = 0

  /** Σ importe CON fecha de liquidación: ya se le rindió al propietario */
  totalLiquidado: number = 0

  /**
   * Σ importe vencido, impago y sin liquidar. Sólo aplica a liquidación real:
   * en la ficticia lo impago ya cuenta dentro de "por liquidar".
   */
  devengadoSinCobrarNiLiquidar: number = 0

  /** Σ importe liquidado al propietario Y ya cobrado al inquilino: circuito cerrado */
  liquidadoYCobrado: number = 0

  /** Σ importe de TODOS los períodos del contrato, hayan vencido o no */
  totalPeriodos: number = 0

  /** Cantidad de períodos vencidos e impagos */
  cantidadPeriodosEnMora: number = 0
  contratoOk!: boolean;
  ultimoPeriodo: any;
  tipoMontoSellado: any;
  tipoSellado: any;
  tipoPunitorio: any;
  tipoMontoAdministrativo: any;
  tipoMontoPunitorio: any;
  lstTiposMoneda: TipoMonedaDto[] = [];
  lstTiposMonto: BaseDto[] = [];
  cantMesesContrato: any;
  mostrarFechaRescincion: boolean = false;
  contratoDetailDto: ContratoDetailDto = new ContratoDetailDto
  rescincion: boolean = false;
  public dialogRef!: MatDialogRef<DialogNuevoPeriodoComponent>


  get datCon() { return this.datosContratoFormGroup.controls; }
  get datMon() { return this.montosContratoFormGroup.controls; }
  get datDetMon() { return this.detalleMontosContratorFormGroup.controls; }

  constructor(
    private formBuilder: FormBuilder,
    private tiposPunitoriosService: TiposPunitorioService,
    private tiposMontosService: TiposMontoService,
    private personasService: PersonasService,
    private propiedadService: PropiedadesService,
    private garantiasService: GarantiasService,
    private spinner: NgxSpinnerService,
    private snackBar: SnackBarService,
    private aRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    // private ref: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver,
    private contratosService: ContratosService,
    private periodoContratoService: PeriodosContratoService,

    private formasPagoService: FormasPagoService,
    private tipoLiquidacionService: TipoLiquidacionService
  ) {

    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ["periodo", "importe", "indiceAjusteContrato", "accion"] :
        ["periodo", "periodoFecha", "fechaPago", "fechaLiquidacion", "fechaAjuste", "importe", "indiceAjusteContrato", "valorAjuste", "ajusteProcesado", "accion"];
    });


    this.datosContratoFormGroup = this.formBuilder.group({
      FechaRescicion: [''],
      AlarmaRescindidoContrato: ['']
    });

    this.detalleMontosContratorFormGroup = this.formBuilder.group({
    });

    this.dataSource.data = []


  }

  // En el constructor, agrega la inicialización del formulario:
  private initializePunitoriosForm(): void {
    this.punitoriosForm = this.formBuilder.group({
      tipoPunitorio: ['', [Validators.required]],
      montoPunitorio: [0, [Validators.required, Validators.min(0)]],
      tipoMontoPunitorio: ['', [Validators.required]]
    });
  }

  permitirSalidaDeRuta(): boolean | Observable<boolean> | Promise<boolean> {
    if (this.contratoOk == true)
      return true

    const confirmacion = window.confirm("¿Quieres salir del formulario y perder los cambios realizados?")
    return confirmacion
  };

  ngOnInit() {
    const routeParams = this.aRoute.snapshot.paramMap;
    this.idContrato = Number(routeParams.get('id'));
    if (this.idContrato > 0)
      this.getContrato(this.idContrato)

    this.initializePunitoriosForm();
    this.getAllTiposPunitorios();
    this.getAllTiposMontos();

    this.initPropietarioEditForm();
    this.loadFormasPago();
    this.loadTiposLiquidacion();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }




  //#region Get
  getContrato(id: number) {
    this.spinner.show("spContrato");
    this.contratosService.getById(id).subscribe(
      async data => {
        this.spinner.hide("spContrato");
        this.contratoDetailDto = data
        await this.setFormContrato()
        await this.contratosService.setContratoDto(data);
        await this.getPropiedadById(this.contratoDetailDto.propiedad.id)
        await this.getPersonaInquilinoById(this.contratoDetailDto.inquilino.persona.id)
        this.spinner.hide('spContratoMain');
      },
      error => {
        this.spinner.hide("spContrato");
        this.snackBar.showError(error, "Error");
      }
    )
  }

  editarPersona(idPersona: number) {
    this.getPersonaByIdAndRoute(idPersona)
  }

  editarPropiedad(idPropiedad: number) {
    this.router.navigate(["/propiedades/", idPropiedad])
  }

  getPersonaByIdAndRoute(idPersona: number) {
    this.spinner.show("spPersona")
    this.personasService.getPersonaById(idPersona)
      .subscribe(
        data => {
          this.spinner.hide("spPersona")
          this.personasService.setPersona(data)
          this.router.navigate(["/personas/editar"])
        },
        error => {
          this.spinner.hide("spPersona")
          this.snackBar.showError(error, "Error");
        });
  }

  getPersonaInquilinoById(id: any) {
    this.spinner.show("spInquilino");
    this.personasService.getPersonaById(id)
      .subscribe(
        data => {
          this.spinner.hide("spInquilino");
          this.personaInquilino = data
        },
        error => {
          this.snackBar.showError(error, "Error");
          this.spinner.hide("spInquilino");
        });
  }

  getAllPropietariosPropiedad(idPropiedad: number) {
    this.spinner.show("spDatosPropietarios");
    this.propiedadService.getAllPropietariosPropiedad(idPropiedad)
      .subscribe(
        data => {
          this.spinner.hide("spDatosPropietarios");
          this.propietariosPropiedad = data.filter(x => x.titular == true)
        },
        error => {
          this.propietariosPropiedad = []
          this.snackBar.showError(error, "Error");
          this.spinner.hide("spDatosPropietarios");
        });
  }

  getPropiedadById(idPropiedad: number) {
    this.spinner.show("spDatosPropiedad");
    this.propiedadService.getById(idPropiedad)
      .subscribe(
        async data => {
          this.spinner.hide("spDatosPropiedad");
          this.propiedad = data
          await this.getAllPropietariosPropiedad(this.propiedad.id)
        },
        error => {
          this.snackBar.showError(error, "Error");
          this.spinner.hide("spDatosPropiedad");
        });
  }

  getAllGarantiasByIdInquilino(idPersonaInquilino: number) {
    this.spinner.show("spGarantia");
    this.garantiasService.getAllGarantiasByInquilino(idPersonaInquilino)
      .subscribe(
        data => {
          this.spinner.hide("spGarantia");
          this.garantiasInquilino = data.filter(element => { return element.activo == true })
        },
        error => {
          this.spinner.hide("spGarantia");
          this.garantiasInquilino = []
          this.snackBar.showError(error, "Error");
        });
  }

  getPeriodosContratoByIdContrato(idContrato: number) {
    this.spinner.show("spPeriodosConstrato");

    this.contratosService.getPeriodosContratoByIdContrato(idContrato).subscribe(
      data => {
        this.dataSource.data = []
        this.spinner.hide("spPeriodosConstrato");
        const sortedData = data.sort((a, b) => {
          return parseInt(a.periodo.toString(), 10) - parseInt(b.periodo.toString(), 10);
        });
        this.dataSource.data = sortedData

        this.calcularTotalesActuales();
        this.data = this.dataSource.data.length >= 1;
      },
      error => {
        this.spinner.hide("spPeriodosConstrato");
        this.snackBar.showError(error, "Error");
      }
    );
  }


  //#endregion

  /**
 * Activa el modo de edición para día de vencimiento
 */
  activarEdicionDiaVto(): void {
    this.modoEdicionDiaVto = true;
    this.diaVencimientoPagoTemp = parseInt(this.contratoDetailDto.diaVencimientoPago);
  }

  /**
   * Cancela la edición del día de vencimiento
   */
  cancelarEdicionDiaVto(): void {
    this.modoEdicionDiaVto = false;
    this.diaVencimientoPagoTemp = 0;
  }

  /**
   * Guarda el cambio del día de vencimiento
   */
  guardarDiaVencimiento(): void {
    // Validar rango
    if (this.diaVencimientoPagoTemp < 1 || this.diaVencimientoPagoTemp > 28) {
      this.snackBar.showError('El día debe estar entre 1 y 28', 'Error de validación');
      return;
    }

    this.spinner.show('spUpdateContrato');

    const updateRequest = {
      idContrato: this.contratoDetailDto.id,
      diaVencimientoPago: this.diaVencimientoPagoTemp
    };

    this.contratosService.updateDiaVencimientoPago(updateRequest)
      .subscribe({
        next: (data) => {
          this.spinner.hide('spUpdateContrato');
          this.snackBar.showSuccess('Día de vencimiento actualizado correctamente', 'Éxito');

          // Actualizar el DTO
          this.contratoDetailDto.diaVencimientoPago = this.diaVencimientoPagoTemp.toString();
          this.modoEdicionDiaVto = false;
        },
        error: (error) => {
          this.spinner.hide('spUpdateContrato');
          this.snackBar.showError(error, 'Error al actualizar');
        }
      });
  }

  //#region Acciones

  checkAlarmaRescicion(event: any) {
    this.contratoDetailDto.fechaResicion = ""
    if (event == true) {
      this.mostrarFechaRescincion = true
    }
    else {
      this.mostrarFechaRescincion = false
    }
  }

  rescisionContrato(resindirContratoRequest: ResindirContratoRequest) {
    this.contratosService.rescisionContrato(resindirContratoRequest)
      .subscribe(
        data => {
          this.snackBar.showSuccess("Contrato resindido de manera correcta.", "Exito");
          this.rescincion = true
        },
        error => {
          this.snackBar.showError(error, "Error");
        }
      )
  }

  crearContrato() {
    this.router.navigate(["/contratos"])
  }

  obtenerUltimoMonto(): number {
    let importeAlquiler: number = 0
    this.dataSource.data.forEach(periodo => {
      if (periodo.importeAlquiler > importeAlquiler) {
        importeAlquiler = periodo.importeAlquiler
      }
    })
    return importeAlquiler
  }

  obtenerUltimoPeriodo(): number {
    let ultimoPeriodo: number = 0
    this.dataSource.data.forEach(periodo => {
      if (periodo.periodo > ultimoPeriodo)
        ultimoPeriodo = periodo.periodo
    })
    ultimoPeriodo++
    return ultimoPeriodo
  }

  agregarPeriodo(periodo: Periodo, adendar: boolean) {

    let fechaDesde = this.contratoDetailDto.fechaComienzo
    let fechaVencimiento = this.contratoDetailDto.fechaVencimiento
    const cantMesesContrato = moment(fechaVencimiento).diff(fechaDesde, "months") + 1;

    if (adendar) {
      if (periodo.periodoDesde <= periodo.periodoHasta) {
        let periodosContratoSummaryDto = this.agregarPeriodoSummery(periodo)
        let adendarContratoRequest: AdendarContratoRequest = new AdendarContratoRequest

        adendarContratoRequest.idContrato = this.idContrato
        adendarContratoRequest.periodoContrato = periodosContratoSummaryDto

        this.adendarContrato(adendarContratoRequest);
      }
      else {
        this.snackBar.showWarn("Ingrese periodos validos.", "Error");
        this.openDialogNuevoPeriodoComponent(true)
      }
    }
    else {
      if (periodo.periodoDesde <= periodo.periodoHasta && periodo.periodoHasta <= cantMesesContrato) {
        let periodosContratoSummaryDto = this.agregarPeriodoSummery(periodo)
        let createPeriodoContratoRequest: CreatePeriodoContratoRequest = new CreatePeriodoContratoRequest

        createPeriodoContratoRequest.idContrato = this.idContrato
        createPeriodoContratoRequest.periodoContrato = periodosContratoSummaryDto

        this.createCollectionPeriodoContrato(createPeriodoContratoRequest)
      }
      else {
        this.snackBar.showWarn("Ingrese periodos validos.", "Error");
        this.openDialogNuevoPeriodoComponent(false)
      }
    }

  }

  agregarPeriodoSummery(periodo: Periodo) {
    let periodosContratoSummaryDto: PeriodoContratoSummaryDto[] = []

    for (periodo.periodoDesde; periodo.periodoDesde <= periodo.periodoHasta; periodo.periodoDesde++) {
      let periodoContratoSummaryDto = new PeriodoContratoSummaryDto
      periodoContratoSummaryDto.descuento = periodo.descuento
      periodoContratoSummaryDto.importeAlquiler = periodo.montoAlquiler
      periodoContratoSummaryDto.incremento = periodo.incremento
      periodoContratoSummaryDto.valorAjuste = periodo.valorAjuste
      periodoContratoSummaryDto.periodo = periodo.periodoDesde
      periodosContratoSummaryDto.push(periodoContratoSummaryDto)
    }
    return periodosContratoSummaryDto
  }


  adendarContrato(adendarContratoRequest: AdendarContratoRequest) {
    this.spinner.show("spPeriodosConstrato");
    this.contratosService.adendar(adendarContratoRequest).subscribe(
      async data => {
        this.spinner.hide("spPeriodosConstrato");
        await this.getPeriodosContratoByIdContrato(this.idContrato);
        await this.getContrato(this.idContrato);
      },
      error => {
        this.spinner.hide("spPeriodosConstrato");
        this.snackBar.showError(error, "Error");
      }
    )
  }

  createCollectionPeriodoContrato(createPeriodoContratoRequest: CreatePeriodoContratoRequest) {
    this.spinner.show("spPeriodosConstrato");
    this.periodoContratoService.createCollection(createPeriodoContratoRequest).subscribe(
      data => {
        this.spinner.hide("spPeriodosConstrato");
        this.getPeriodosContratoByIdContrato(this.idContrato);
      },
      error => {
        this.spinner.hide("spPeriodosConstrato");
        this.snackBar.showError(error, "Error");
      }
    )
  }

  calcularTotalesActuales() {
    let tipoMontoHonorarios = this.contratoDetailDto.tipoMontoAdministrativo
    let tipoMontoSellado = this.contratoDetailDto.tipoMontoSellado
    let montoHonorarios = this.contratoDetailDto.montoAdministrativo
    let montoSellado = this.contratoDetailDto.montoSellado


    this.totalMontoAlquiler = 0
    this.totalDescuento = 0
    this.totalIncrementos = 0
    this.dataSource.data.forEach(
      periodo => {
        this.totalMontoAlquiler += periodo.importeAlquiler
        this.totalDescuento += periodo.descuento
        this.totalIncrementos += periodo.incremento
      }
    )

    //Calculo Honorarios
    if (tipoMontoHonorarios.id == TiposMontos.PorcentajeAlquiler) {
      //Porcentaje
      this.totalComision = ((this.totalMontoAlquiler * montoHonorarios) / 100)
    }
    else {
      this.totalComision = montoHonorarios
    }

    //Calculo Sellado
    if (tipoMontoSellado.id == TiposMontos.PorcentajeAlquiler) {
      //Porcentaje
      this.totalSellado = ((this.totalMontoAlquiler * montoSellado) / 100)
    }
    else {
      this.totalSellado = montoSellado
    }
    this.total = this.totalMontoAlquiler - this.totalDescuento + this.totalIncrementos + this.totalSellado + this.totalComision

    this.calcularTotalesCobranza()
  }

  /**
   * Totales de cobranza y liquidación, para analizar mora sobre los períodos del contrato.
   *
   *   Devengado          -> ya venció (Fecha Vencimiento <= hoy), se haya cobrado o no
   *   Pagado             -> tiene Fecha Pago
   *   A cobrar           -> sin Fecha Pago, incluidos los que todavía no vencieron
   *   Deuda Inquilino    -> sin Fecha Pago Y ya vencido  == la mora real
   *   Liquidado s/cobrar -> ya se le liquidó al propietario pero el inquilino no pagó
   *   Por liquidar       -> liquidable hoy, según el tipo de liquidación del contrato
   */
  calcularTotalesCobranza() {
    this.totalDevengado = 0
    this.totalPagado = 0
    this.totalACobrar = 0
    this.deudaInquilino = 0
    this.liquidadoSinCobrar = 0
    this.totalPorLiquidar = 0
    this.totalLiquidado = 0
    this.devengadoSinCobrarNiLiquidar = 0
    this.liquidadoYCobrado = 0
    this.totalPeriodos = 0
    this.cantidadPeriodosEnMora = 0

    const hoy = new Date()
    hoy.setHours(23, 59, 59, 999)

    this.dataSource.data.forEach(periodo => {
      const importe = periodo.importeAlquiler ?? 0

      const tienePago = this.tieneFecha(periodo.fechaPago)
      const tieneLiquidacion = this.tieneFecha(periodo.fechaLiquidacion)
      const venci = this.aFecha(periodo.fechaVencimiento)
      const estaVencido = venci != null && venci <= hoy

      if (estaVencido)
        this.totalDevengado += importe

      if (tienePago)
        this.totalPagado += importe
      else {
        this.totalACobrar += importe

        if (estaVencido) {
          this.deudaInquilino += importe
          this.cantidadPeriodosEnMora++
        }

        if (tieneLiquidacion)
          this.liquidadoSinCobrar += importe
      }

      this.totalPeriodos += importe

      if (tieneLiquidacion) {
        this.totalLiquidado += importe

        if (tienePago)
          this.liquidadoYCobrado += importe

        return
      }

      if (this.esLiquidacionFicticia) {
        // Ficticia: se le rinde al propietario aunque el inquilino no pague.
        // Alcanza con que el período se haya devengado.
        if (estaVencido)
          this.totalPorLiquidar += importe
      }
      else {
        // Real: sólo lo cobrado. Lo vencido e impago queda a la espera.
        if (tienePago)
          this.totalPorLiquidar += importe
        else if (estaVencido)
          this.devengadoSinCobrarNiLiquidar += importe
      }
    })
  }

  /**
   * Si el contrato liquida de forma ficticia.
   *
   * Un contrato sin tipo cargado se trata como real: es el criterio
   * conservador, no se muestra como liquidable plata que no entró.
   */
  get esLiquidacionFicticia(): boolean {
    return this.contratoDetailDto?.tipoLiquidacion?.id === TiposLiquidacion.Ficticia
  }

  /** Las fechas vacías llegan como null, "" o 01/01/0001 según el origen */
  private tieneFecha(fecha: any): boolean {
    return this.aFecha(fecha) != null
  }

  private aFecha(fecha: any): Date | null {
    if (!fecha)
      return null

    if (fecha === '01/01/0001' || String(fecha).startsWith('0001-01-01'))
      return null

    const parsed = new Date(fecha)

    return isNaN(parsed.getTime()) ? null : parsed
  }

  calcularTotalesIniciales(key: string) {
    // let tipoMontoHonorarios = this.contratoDetailDto.tipoMontoAdministrativo
    // let montoHonorarios = this.contratoDetailDto.montoAdministrativo
    // let montoTotalComision = this.contratoDetailDto.montoTotalHonorario
    // //Calculo Honorarios
    // if (tipoMontoHonorarios.id == TiposMontos.PorcentajeAlquiler) {
    //   //Porcentaje
    //   montoTotalComision = ((this.contratoDetailDto.montoTotalContrato * montoHonorarios) / 100)
    // }
    // else {
    //   montoTotalComision = montoHonorarios
    // }

    let montoTotalSellado = this.contratoDetailDto.montoTotalSellado
    let montoTotalHonorario = this.contratoDetailDto.montoTotalHonorario
    let montoTotalContrato = this.contratoDetailDto.montoTotalContrato - montoTotalSellado - montoTotalHonorario

    let montoTotal = montoTotalContrato + montoTotalHonorario + montoTotalSellado

    if (!isFalsy(key))
      switch (key) {
        case 'montoTotalContrato':
          return montoTotalContrato
        case 'montoTotalSellado':
          return montoTotalSellado
        case 'montoTotalComision':
          return montoTotalHonorario
        case 'montoTotal':
          return montoTotal
        default:
          return 0
      }
    else
      return 0




  }


  setFormContrato() {
    let contrato = this.contratoDetailDto
    this.dataSource.data = this.contratoDetailDto.periodosContratos.sort((a, b) => a.periodo - b.periodo)

    this.data = this.dataSource.data.length >= 1 ? true : false
    this.dataSource = new MatTableDataSource<PeriodoContratoDetailDto>(this.dataSource.data)
    this.calcularTotalesActuales()
  }

  eliminarPeriodo(periodo: any) {
    if (this.dataSource.data.length == periodo.periodo) {
      this.spinner.show("spPeriodosConstrato");
      this.periodoContratoService.delete(periodo.id).subscribe(
        data => {
          this.spinner.hide("spPeriodosConstrato");
          this.getPeriodosContratoByIdContrato(this.idContrato);
        },
        error => {
          this.spinner.hide("spPeriodosConstrato");
          this.snackBar.showError(error, "Error");
        }
      )
    }
    else {
      this.snackBar.showWarn("Borre los periodos de manera ordenada.", "Error");
    }
  }

  //#endregion Acciones

  //#region Dialog

  openDialogNuevoPeriodoComponent(adendar: boolean) {
    let ultimoPeriodo = this.obtenerUltimoPeriodo()
    let ultimoMonto = this.obtenerUltimoMonto()
    let totalPeriodos = this.calcularDuracionPeriodo(this.contratoDetailDto.fechaComienzo, this.contratoDetailDto.fechaVencimiento)
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      event: AccionesDialog.Agregar,
      ultimoPeriodo: ultimoPeriodo,
      cantidadPeriodos: totalPeriodos,
      tipoContrato: this.contratoDetailDto.tipoContrato.id,
      ultimoMonto: ultimoMonto,
      adendar: adendar
    }

    const dialogRef = this.dialog.open(DialogNuevoPeriodoComponent,
      dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event == AccionesDialog.Agregar) {
        this.agregarPeriodo(result.data, adendar);
      }
    });
  }

  calcularDuracionPeriodo(fechaDesde: any, fechaHasta: any) {
    const fechaComienzo = moment(new Date(fechaDesde))
    const fechaVencimiento = moment(new Date(fechaHasta))
    const meses = fechaVencimiento.diff(fechaComienzo, 'months')
    return meses + 1
  }

  openDialogGenerarResumen() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "400px"
    dialogConfig.data = { event: AccionesDialog.Agregar, contrato: this.contratoDetailDto }
    dialogConfig.autoFocus = false
    dialogConfig.disableClose = true

    const dialogRef = this.dialog.open(DialogGenerarResumenComponent,
      dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
    });
  }


  openDialogAdendaContratoComponent(adendar: boolean) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(DialogAdendaContratoComponent,
      dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      result && result.event == AccionesDialog.Aceptar ? this.openDialogNuevoPeriodoComponent(adendar) : false
    });
  }

  openDialogNuevaLiquidacion() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "1080px"
    dialogConfig.data = this.contratoDetailDto
    dialogConfig.autoFocus = false
    dialogConfig.disableClose = true

    const dialogRef = this.dialog.open(DialogNuevaLiquidacionComponent,
      dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialogRescisionContrato() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false
    dialogConfig.disableClose = false
    dialogConfig.data = this.contratoDetailDto

    const dialogRef = this.dialog.open(DialogRescisionContratoComponent,
      dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event == AccionesDialog.Aceptar) { }
    });
  }

  openDialogNuevoRecibo() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "100%"
    dialogConfig.data = { event: AccionesDialog.Agregar, contrato: this.contratoDetailDto }
    dialogConfig.autoFocus = false
    dialogConfig.disableClose = true

    const dialogRef = this.dialog.open(DialogNuevoReciboComponent,
      dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openDialog(periodoContratoDetail: PeriodoContratoDetailDto) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.data = periodoContratoDetail,
      dialogConfig.width = "50%"

    const dialogRef = this.dialog.open(DialogVerPeriodoContratoDetailDtoComponent, dialogConfig);
  }

  //#endregion

  //#region Editar Punitorios


  getAllTiposPunitorios() {
    this.spinner.show("spTiposPunitorios");
    this.tiposPunitoriosService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spTiposPunitorios");
          this.lstTiposPunitorio = data.sort((a, b) => a.descripcion.localeCompare(b.descripcion));
        },
        error => {
          this.spinner.hide("spTiposPunitorios");
          this.snackBar.showError(error, "Error");
        });
  }

  getAllTiposMontos() {
    this.spinner.show("spTiposMontos");
    this.tiposMontosService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spTiposMontos");
          this.lstTiposMontoPunitorio = data
        },
        error => {
          this.spinner.hide("spTiposMontos");
          this.snackBar.showError(error, "Error");
        });
  }

  // Activar modo edición
  activarEdicionPunitorios(): void {
    this.modoEdicionPunitorios = true;

    // Guardar datos originales
    this.datosOriginalesPunitorios = {
      tipoPunitorio: this.contratoDetailDto.tipoPunitorio?.id || null,
      montoPunitorio: this.contratoDetailDto.montoPunitorio || 0,
      tipoMontoPunitorio: this.contratoDetailDto.tipoMontoPunitorio?.id || null
    };

    // Cargar datos en el formulario
    this.punitoriosForm.patchValue(this.datosOriginalesPunitorios);
  }

  // Cancelar edición
  cancelarEdicionPunitorios(): void {
    this.modoEdicionPunitorios = false;
    this.datosOriginalesPunitorios = null;
    this.punitoriosForm.reset();
  }

  // Guardar cambios
  guardarMontosPunitorios(): void {
    if (this.punitoriosForm.invalid) {
      this.marcarCamposComoTocadosPunitorios();
      this.snackBar.showError('Complete todos los campos requeridos', 'Error de validación');
      return;
    }

    const formData = this.punitoriosForm.value;

     const updateRequest = {
      idContrato: this.contratoDetailDto.id,
      idTipoPunitorio: formData.tipoPunitorio.id,
      montoPunitorio: formData.montoPunitorio,
      idTipoMontoPunitorio: formData.tipoMontoPunitorio
    };

    this.spinner.show('spUpdateContrato');

    this.contratosService.updateMontosPunitorios(updateRequest)
      .subscribe({
        next: (data) => {
          this.spinner.hide('spUpdateContrato');
          this.snackBar.showSuccess('Montos punitorios actualizados correctamente', 'Éxito');
          this.modoEdicionPunitorios = false;

          // Actualizar los datos en el DTO
          var tipoPunitorio = this.lstTiposPunitorio.find(t => t.id === formData.tipoPunitorio.id);
          if(tipoPunitorio)
          this.contratoDetailDto.tipoPunitorio = tipoPunitorio

          this.contratoDetailDto.montoPunitorio = formData.montoPunitorio;

          var tipoMontoPunitorio = this.lstTiposMontoPunitorio.find(t => t.id === formData.tipoMontoPunitorio);
          if(tipoMontoPunitorio)
          this.contratoDetailDto.tipoMontoPunitorio = tipoMontoPunitorio

          this.datosOriginalesPunitorios = null;
        },
        error: (error) => {
          this.spinner.hide('spUpdateContrato');
          this.snackBar.showError(error, "Error al actualizar");
        }
      });
  }

  openDialogEditar(periodoContratoDetail: PeriodoContratoDetailDto) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = false;
      dialogConfig.data = periodoContratoDetail
      dialogConfig.width = "60%"

      const dialogRef = this.dialog.open(DialogUpdatePeriodoContratoComponent, dialogConfig);

      dialogRef.afterClosed().subscribe(result => {
        // Si se editó correctamente, guardar filtro y recargar datos
        if (result) {
          this.getPeriodosContratoByIdContrato(this.idContrato)
        }
      });
    }

  // Marcar campos como tocados
  private marcarCamposComoTocadosPunitorios(): void {
    Object.keys(this.punitoriosForm.controls).forEach(key => {
      this.punitoriosForm.get(key)?.markAsTouched();
    });
  }

  // Eventos de cambio
  onTipoPunitorioChange(event: any): void {
 let tipoPunitorio = event.value as TipoPunitorioDto;

  if (tipoPunitorio.id == TiposPunitorio.MontoFijo) {
    this.punitoriosForm.controls["montoPunitorio"].setValue(0);
    // Mantener habilitado
  } else {
    this.punitoriosForm.controls["montoPunitorio"].setValue(tipoPunitorio.valor);
    // También mantener habilitado pero agregar validador custom
    this.punitoriosForm.controls["montoPunitorio"].setValidators([Validators.required]);
  }
  }

  onTipoMontoPunitorioChange(event: any): void {
    // Lógica adicional si es necesaria
  }

  //#endregion

  //#region  Edicion de Propietarios

  /**
 * Inicializa el formulario de edición de propietario
 */
  private initPropietarioEditForm(): void {
    this.propietarioEditForm = this.formBuilder.group({
      comision: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
      formaPago: ['', [Validators.required]],
      tipoLiquidacion: ['', [Validators.required]]
    });
  }

  /**
   * Carga las formas de pago
   */
  loadFormasPago(): void {
    this.spinner.show('spFormaPago');
    this.formasPagoService.getAll()
      .subscribe({
        next: (data) => {
          this.spinner.hide('spFormaPago');
          this.lstFormasPago = data;
        },
        error: (error) => {
          this.spinner.hide('spFormaPago');
          this.snackBar.showError(error, "Error al cargar formas de pago");
        }
      });
  }

  /**
   * Carga los tipos de liquidación
   */
  loadTiposLiquidacion(): void {
    this.spinner.show('spTipoLiquidacion');
    this.tipoLiquidacionService.getAll()
      .subscribe({
        next: (data) => {
          this.spinner.hide('spTipoLiquidacion');
          this.lstTiposLiquidacion = data;
        },
        error: (error) => {
          this.spinner.hide('spTipoLiquidacion');
          this.snackBar.showError(error, "Error al cargar tipos de liquidación");
        }
      });
  }

  /**
   * Activa el modo de edición del propietario
   */
  activarEdicionPropietario(): void {
    this.modoEdicionPropietario = true;

    // Guardar datos originales
    this.datosOriginalesPropietario = {
      comision: this.contratoDetailDto.porcentajeComisionPropietario,
      formaPago: this.contratoDetailDto.formaPagoPropietario?.id,
      tipoLiquidacion: this.contratoDetailDto.tipoLiquidacion?.id
    };

    // Cargar datos en el formulario
    this.propietarioEditForm.patchValue({
      comision: this.contratoDetailDto.porcentajeComisionPropietario || 0,
      formaPago: this.contratoDetailDto.formaPagoPropietario?.id || '',
      tipoLiquidacion: this.contratoDetailDto.tipoLiquidacion?.id || ''
    });
  }

  /**
   * Cancela la edición del propietario
   */
  cancelarEdicionPropietario(): void {
    this.modoEdicionPropietario = false;
    this.datosOriginalesPropietario = null;
    this.propietarioEditForm.reset();
  }

  /**
   * Guarda los cambios del propietario
   */
  guardarDatosPropietario(): void {
    if (this.propietarioEditForm.invalid) {
      this.marcarCamposComoTocados(this.propietarioEditForm);
      this.snackBar.showError('Complete todos los campos correctamente', 'Error de validación');
      return;
    }

    const formData = this.propietarioEditForm.value;

    const updateRequest = {
      idContrato: this.contratoDetailDto.id,
      porcentajeComisionPropietario: formData.comision,
      idFormaPagoPropietario: formData.formaPago,
      idTipoLiquidacion: formData.tipoLiquidacion
    };

    this.spinner.show('spDatosPropietarios');

    this.contratosService.updateDatosPropietario(updateRequest)
      .subscribe({
        next: (data) => {
          this.spinner.hide('spDatosPropietarios');
          this.snackBar.showSuccess('Datos del propietario actualizados correctamente', 'Éxito');

          // Actualizar el DTO
          this.contratoDetailDto.porcentajeComisionPropietario = formData.comision;
          var formaPago = this.lstFormasPago.find(f => f.id === formData.formaPago);
          if (formaPago)
            this.contratoDetailDto.formaPagoPropietario = formaPago

          var tipoLiquidacion = this.lstTiposLiquidacion.find(t => t.id === formData.tipoLiquidacion);
          if (tipoLiquidacion)
            this.contratoDetailDto.tipoLiquidacion = tipoLiquidacion

          this.modoEdicionPropietario = false;
          this.datosOriginalesPropietario = null;
        },
        error: (error: string) => {
          this.spinner.hide('spDatosPropietarios');
          this.snackBar.showError(error, 'Error al actualizar');
        }
      });
  }

  /**
   * Marca todos los campos como tocados
   */
  private marcarCamposComoTocados(form: FormGroup): void {
    Object.keys(form.controls).forEach(key => {
      form.get(key)?.markAsTouched();
    });
  }

  //#endregion

  isFalsy(valor: any) {
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }




}
